/**
 * 店铺 AI 自主营销 menuId SSOT（patch 228）
 */
export const STORE_AUTONOMOUS_MARKETING_MENU_IDS = {
  group: 990450,
  desk: 990451,
  view: 990452,
  gate: 990453
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/storeAutonomousMarketing.js